module.exports = __webpack_public_path__ + "static/media/mono_manual_osc_sync.22192e82.svg";